import { vue_instance } from './main.js';

const user_meta_actions = localStorage.getItem('meta_actions')


//checks provider detail service
const provider_detail_service = (next) =>{
	if(user_meta_actions.includes('view_all_provider_details_including_roles')){
		next()
	  }else{
		next({name: 'Login'})
	  }
}

export default provider_detail_service


// WEBPACK FOOTER //
// ./src/route.service.js